import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=49f47bd9"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=49f47bd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports